export default __webpack_public_path__ + "static/media/armep1.9e87b2cb.jpg";